//
// Copyright (c) 2021 Astute Global, Inc.
//

import { ImageBlockEditing, LinkImageUI } from "ckeditor5";
import AkLinkEditing from "./akLinkEditing";
import AkLinkUi from "./akLinkUi";

export default class AkLinkImageUi extends LinkImageUI {
  static get requires() {
    return [AkLinkEditing, AkLinkUi, ImageBlockEditing];
  }

  static get pluginName() {
    return "AkLinkImageUi";
  }
}
